<template>
  <section class="context-menu" @mouseleave.stop="handleMouseout">
    <div v-show="isVisible" class="backdrop" @click="close" @contextmenu.stop.prevent="close" />
    <ul v-show="isVisible" ref="menu" :class="`context-menu-list elevation-${level + 2}`" :style="CSS_VARS">
      <li v-if="loadingPlaceholder" class="loading">
        <v-progress-circular width="2" color="primary" size="24" indeterminate />
      </li>
      <li
        v-for="(item, i) in menu"
        :key="i"
        :class="{
          disabled: item.isDisabled,
          'has-nested-menu': item.menu || item.isLoading
        }"
        @mouseenter.stop="handleMouseover($event, item.menu, i)"
        @click="executeAction(item)"
      >
        <v-icon v-if="item.icon" class="icon">{{ item.icon }}</v-icon>
        <div class="label">{{ item.label }}</div>
        <v-icon v-if="item.menu || item.isLoading" class="sub-menu">mdi-menu-right</v-icon>
      </li>
    </ul>
    <EcsContextMenuList
      v-if="hasNestedMenus || isLoading"
      ref="subMenu"
      :level="level + 1"
      :loading-placeholder="isLoading"
    />
  </section>
</template>

<script>
import EcsContextMenuList from '@/components/ecs-context-menu/EcsContextMenuList';

export default {
  name: 'EcsContextMenuList',

  components: {
    EcsContextMenuList
  },

  props: {
    level: {
      type: Number,
      default: 1
    },
    loadingPlaceholder: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      menu: [],
      position: {
        type: Object,
        default() {
          return {};
        }
      },
      finalPosition: {
        type: Object,
        default() {
          return {};
        }
      },
      borderGap: 16,
      isVisible: false,
      isReversed: false,
      hoveredListItem: {
        type: Object,
        default() {
          return {};
        }
      }
    };
  },

  computed: {
    isLoading() {
      return this.menu && this.menu.some(item => item.isLoading);
    },

    hasNestedMenus() {
      return this.menu && this.menu.flatMap(item => item.menu || []).length;
    },

    CSS_VARS() {
      return {
        '--top': `${this.finalPosition.y}px`,
        '--left': `${this.finalPosition.x}px`
      };
    }
  },

  watch: {
    menu: {
      deep: true,
      handler: function() {
        const subMenu = this.$refs.subMenu;

        if (subMenu && this.hoveredListItem && this.menu && this.menu[this.hoveredListItem.index]) {
          const { top, right } = this.hoveredListItem.target.getBoundingClientRect();
          subMenu.open(this.menu[this.hoveredListItem.index].menu, { x: right, y: top });
        }
      }
    },
    position() {
      this.calcMenuPosition();
    }
  },

  methods: {
    open(menu, position) {
      this.menu = menu;
      this.position = position;
      this.isVisible = true;
      this.isReversed = false;
      this.hoveredListItem = null;

      this.calcMenuPosition();
    },

    close() {
      this.isVisible = false;
      this.menu = [];
      this.position = {};
      this.isReversed = false;
      if (this.$refs.subMenu) {
        this.$refs.subMenu.close();
      }
    },

    executeAction(item) {
      if (item.action) {
        item.action(item.id);
      }
      this.close();
    },

    async calcMenuPosition() {
      await this.$nextTick();
      const menu = this.$refs.menu;
      let x = this.position.x;
      let y = this.position.y;

      if (!menu) {
        return { x, y };
      }

      const availableWidth = document.body.clientWidth - this.borderGap;
      const availableHeight = document.body.clientHeight - this.borderGap;
      const menuWidth = menu.getBoundingClientRect().width;
      const menuHeight = menu.getBoundingClientRect().height;
      const parent = this.$el.parentElement;
      const parentMenu = parent.querySelector('.context-menu-list');

      if (this.level > 1 && parent.__vue__.isReversed) {
        x = parentMenu.getBoundingClientRect().left - menuWidth - 1;
        this.isReversed = true;
      } else if (x + menuWidth > availableWidth) {
        if (this.level > 1) {
          x = parentMenu.getBoundingClientRect().left - menuWidth - 1;
          this.isReversed = true;
        } else {
          x = availableWidth - menuWidth;
        }
      } else {
        x += 1;
      }

      if (y + menuHeight > availableHeight) {
        y = availableHeight - menuHeight;
      }

      this.finalPosition = { x, y };
    },

    handleMouseover({ target }, menu, index) {
      const subMenu = this.$refs.subMenu;

      if (subMenu) {
        this.hoveredListItem = { target, index };
        const { top, right } = target.getBoundingClientRect();
        subMenu.open(menu, { x: right, y: top });
      } else {
        this.hoveredListItem = null;
      }
    },

    handleMouseout() {
      if (this.level !== 1) {
        this.close();
      }
    }
  }
};
</script>

<style src="./scoped.scss" scoped lang="scss" />
